function initSpaceProduct() {
  document.querySelectorAll('.sp-page').forEach(function (page) {
    if (page.dataset.spInit) return;
    page.dataset.spInit = 'true';

    var sectionId = page.dataset.sectionId;

    // ---------- starfield ----------
    var canvas = document.getElementById('spStars-' + sectionId);
    if (canvas) {
      var ctx = canvas.getContext('2d');
      function resize() {
        canvas.width = window.innerWidth;
        canvas.height = document.body.scrollHeight;
      }
      resize();
      window.addEventListener('resize', resize);

      var stars = Array.from({ length: 200 }, function () {
        return {
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          r: Math.random() * 1.3 + 0.2,
          s: Math.random() * 0.02 + 0.005,
          phase: Math.random() * Math.PI * 2
        };
      });

      function draw(t) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#fff';
        stars.forEach(function (st) {
          var alpha = 0.35 + 0.65 * Math.abs(Math.sin(t * st.s + st.phase));
          ctx.globalAlpha = alpha;
          ctx.beginPath();
          ctx.arc(st.x, st.y, st.r, 0, Math.PI * 2);
          ctx.fill();
        });
        ctx.globalAlpha = 1;
        requestAnimationFrame(draw);
      }
      requestAnimationFrame(draw);
    }

    // ---------- thumbnail gallery ----------
    var thumbs = page.querySelectorAll('[data-sp-thumb]');
    var mainImageWrap = document.getElementById('spMainImage-' + sectionId);
    var mainImg = document.getElementById('spMainImg-' + sectionId);
    var activeIndex = 0;

    function setActiveThumb(index) {
      if (!thumbs.length) return;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
      });
      var thumb = thumbs[index];
      if (!thumb || !mainImg) return;

      mainImageWrap.classList.add('is-swapping');
      setTimeout(function () {
        mainImg.src = thumb.dataset.full;
        mainImg.alt = thumb.dataset.alt || '';
        mainImageWrap.classList.remove('is-swapping');
      }, 200);

      activeIndex = index;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setActiveThumb(i); });
    });

    var prevBtn = page.querySelector('[data-sp-prev]');
    var nextBtn = page.querySelector('[data-sp-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var next = (activeIndex - 1 + thumbs.length) % thumbs.length;
        setActiveThumb(next);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var next = (activeIndex + 1) % thumbs.length;
        setActiveThumb(next);
      });
    }

    // ---------- size selection ----------
    var sizeButtons = page.querySelectorAll('[data-sp-size]');
    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        sizeButtons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    // ---------- tabs ----------
    var tabHeads = page.querySelectorAll('[data-sp-tab]');
    var tabPanels = page.querySelectorAll('[data-sp-panel]');
    tabHeads.forEach(function (head) {
      head.addEventListener('click', function () {
        var index = head.dataset.spTab;
        tabHeads.forEach(function (h) { h.classList.remove('is-active'); });
        tabPanels.forEach(function (p) { p.classList.remove('is-active'); });
        head.classList.add('is-active');
        var panel = page.querySelector('[data-sp-panel="' + index + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });

    // ---------- buy it now: add to cart, then go to /cart where the working checkout flow is ----------
    var buyNowBtn = page.querySelector('[data-sp-buy-now]');
    var form = page.querySelector('.sp-form');
    if (buyNowBtn && form) {
      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();
        buyNowBtn.disabled = true;
        var originalText = buyNowBtn.textContent;
        buyNowBtn.textContent = 'Adding...';

        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.location.href = '/cart';
          })
          .catch(function () {
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = originalText;
            alert('Could not add to cart. Please try again.');
          });
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSpaceProduct);
} else {
  initSpaceProduct();
}
document.addEventListener('shopify:section:load', initSpaceProduct);